import { render, staticRenderFns } from "./IR_Contacts.vue?vue&type=template&id=7c246dad&scoped=true"
import script from "./IR_Contacts.vue?vue&type=script&lang=js"
export * from "./IR_Contacts.vue?vue&type=script&lang=js"
import style0 from "./IR_Contacts.vue?vue&type=style&index=0&id=7c246dad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c246dad",
  null
  
)

export default component.exports